// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2JmSw","buttons":"SendReceipts_buttons__1jdqK","email":"SendReceipts_email__3DLv7","bookApptTitle":"SendReceipts_bookApptTitle__1reeR"};